import { clientEnvIsDesktop } from "@/modules/client-env/isDesktop";
import { clientEnvIsMobile } from "@/modules/client-env/isMobile";

export const clientEnvIsMobileBrowser = () => {
  return clientEnvIsMobile() && !clientEnvIsDesktop();
};
